import type { InputEvent, InputProvider } from './InputProvider';

export class InputManager {
  private _providers: InputProvider[] = [];
  private _sendInput: (event: InputEvent) => void;
  private _attached = false;

  constructor(sendInput: (event: InputEvent) => void) {
    this._sendInput = sendInput;
  }

  addProvider(provider: InputProvider): void {
    if (this._providers.some(p => p.name === provider.name)) {
      return;
    }
    provider.onInput = this._sendInput;
    this._providers.push(provider);
  }

  removeProvider(name: string): void {
    const idx = this._providers.findIndex(p => p.name === name);
    if (idx === -1) return;
    const provider = this._providers[idx];
    if (this._attached) {
      provider.detach();
    }
    provider.onInput = null;
    this._providers.splice(idx, 1);
  }

  attachAll(element: HTMLElement): void {
    for (const provider of this._providers) {
      provider.attach(element);
    }
    this._attached = true;
  }

  detachAll(): void {
    for (const provider of this._providers) {
      provider.detach();
    }
    this._attached = false;
  }

  suspendAll(): void {
    for (const provider of this._providers) {
      provider.suspend();
    }
  }

  resumeAll(): void {
    for (const provider of this._providers) {
      provider.resume();
    }
  }

  get providers(): readonly InputProvider[] {
    return this._providers;
  }
}
